import { useState, useEffect } from 'react';
import { Zap } from 'lucide-react';

const VoltageLayersControl = ({ onVoltageClassesChange }) => {
  const voltageOptions = [
    { code: 133, label: '0.22 кВ', color: 'purple' },
    { code: 130, label: '0.4 кВ', color: 'red' },
    { code: 129, label: '6 кВ',  color: 'yellow' },
    { code: 128, label: '10 кВ', color: 'orange' },
    { code: 131, label: '35 кВ', color: 'green' },
    { code: 134, label: '110 кВ', color: 'blue' },
    { code: 1, label: 'Не указан', color: 'black' },
    // добавляй новые классы сюда
  ];

  const [selectedCodes, setSelectedCodes] = useState(
    voltageOptions.map(opt => opt.code) // по умолчанию все включены
  );

  const [isOpen, setIsOpen] = useState(false); // панель по умолчанию свёрнута

  const toggleCode = (code) => {
    setSelectedCodes(prev =>
      prev.includes(code)
        ? prev.filter(c => c !== code)
        : [...prev, code]
    );
  };

  const toggleAll = () => {
    if (selectedCodes.length === voltageOptions.length) {
      setSelectedCodes([]); // выключить все
    } else {
      setSelectedCodes(voltageOptions.map(opt => opt.code)); // включить все
    }
  };

  // Уведомляем родителя при изменении выбора
  useEffect(() => {
    onVoltageClassesChange(selectedCodes);
  }, [selectedCodes, onVoltageClassesChange]);

  const allSelected = selectedCodes.length === voltageOptions.length;

  return (
    <div
      style={{
        position: 'absolute',
        top: '190px',
        right: '20px',
        zIndex: 1000,
      }}
    >
      <div style={{ position: 'relative', display: 'inline-block' }}>
        
        {/* Квадратная кнопка ⚡ */}
        <button
          onClick={() => setIsOpen(!isOpen)}
          style={{
            width: '48px',
            height: '48px',
            background: 'white',
            border: 'none',
            borderRadius: '12px',
            boxShadow: '0 4px 15px rgba(0,0,0,0.25)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '28px',
            cursor: 'pointer',
            transition: 'transform 0.2s',
          }}
          title="Класс напряжения"
        >
          <Zap size={20} color="#3b82f6" fill="#3b82f6" />
        </button>

        {/* Панель (absolute относительно кнопки) */}
        {isOpen && (
          <div
            style={{
              position: 'absolute',
              top: '100%',        // строго под кнопкой
              right: '0',
              marginTop: '8px',
              background: 'white',
              borderRadius: '10px',
              boxShadow: '0 6px 20px rgba(0,0,0,0.3)',
              padding: '14px 16px',
              minWidth: '170px',
              zIndex: 1001,
            }}
          >
            {/* Кнопка Вкл/выкл все */}
            <button
              onClick={toggleAll}
              style={{
                width: '100%',
                padding: '10px',
                marginBottom: '12px',
                background: allSelected ? '#e74c3c' : '#27ae60',
                color: 'white',
                border: 'none',
                borderRadius: '8px',
                cursor: 'pointer',
                fontWeight: 'bold',
                fontSize: '14px',
              }}
            >
              {allSelected ? 'Выключить все' : 'Включить все'}
            </button>

            {/* Список классов */}
            {voltageOptions.map(({ code, label, color }) => (
              <label
                key={code}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  margin: '9px 0',
                  cursor: 'pointer',
                  userSelect: 'none',
                }}
              >
                <input
                  type="checkbox"
                  checked={selectedCodes.includes(code)}
                  onChange={() => toggleCode(code)}
                  style={{ marginRight: '10px', accentColor: color, width: '18px', height: '18px' }}
                />
                <span
                  style={{
                    display: 'inline-block',
                    width: '18px',
                    height: '4px',
                    backgroundColor: color,
                    marginRight: '10px',
                    borderRadius: '3px',
                    
                  }}
                />
                {label}
              </label>
            ))}

           {/* <small style={{ color: '#666', display: 'block', marginTop: '12px', textAlign: 'center' }}>
              Выбрано: {selectedCodes.length} из {voltageOptions.length}
            </small>*/}
          </div>
        )}
      </div>
    </div>
  );
};

export default VoltageLayersControl;